import * as machinemotion from '@vse/api/machinemotion';
import { type PasswordTarget } from 'src/ConfigInfo';
import { parseSetPasswordResponseErrors, type SetPasswordResponse } from './setPasswordErrorParser';

/**
 * Validates a password on the passwordTargets.
 *
 * @param passwordTargets The targets to set the password on.
 * @param password The password to validate.
 * @returns A promise that resolves without parameters, or rejects with a list of errors.
 */
export async function validatePassword (passwordTargets: PasswordTarget[], password: string): Promise<void> {
  // This is a rather strange API, but doing this validates the password, it doesn't set it.
  await setNewPassword(passwordTargets, password, password, password);
}

/**
 * Sets a new password on the passwordTargets.
 *
 * @param passwordTargets The targets to set the password on.
 * @param password The new password.
 * @param passwordConfirmation A confirmation of the new password.
 * @param oldPassword What you think the old password is. Should be an empty string if no password was set before.
 * @returns A promise that resolves without parameters, or rejects with a list of errors.
 */
export async function setNewPassword (passwordTargets: PasswordTarget[], password: string, passwordConfirmation: string, oldPassword: string): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    void machinemotion.setPassword(passwordTargets, password, passwordConfirmation, oldPassword, (setPasswordResponse?: SetPasswordResponse) => {
      const errors = parseSetPasswordResponseErrors(setPasswordResponse);
      if (errors.length > 0) {
        reject(errors);
      }

      resolve();
    });
  });
}
